import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { ReptoolModal } from "../../utilities/ReptoolModal.tsx";
import { BasicFetch } from "../../../utils/BasicFetch.ts";
import { Clutch } from '../../../types/Clutch';
import { ClutchItem } from '../Clutches.tsx';
import { useRepToolContext } from '../../../RepToolContext.tsx';
interface Props {
  closeModal: () => void;
  onDelete: () => void;
  editingClutch: Clutch;
}

export const DeleteClutchModal: React.FC<Props> = ({ onDelete, closeModal, editingClutch }) => {
  const [saving, setSaving] = React.useState(false);
  const { appendControls } = useRepToolContext();
  const deleteClutch = () => {
    BasicFetch({
      url: `${(window as any).serverLocation}/clutch/${editingClutch.id}/delete`,
      method: 'DELETE',
      contentType: 'application/json',
      data: {},
      onSuccess: (data) => {
        alert('Clutch deleted');
        onDelete();
        closeModal();
      },
      onFail: (error) => {
        alert('Error deleting clutch');
      },
      onFinish: () => {
        setSaving(false);
      }
    })
  }

  useEffect(() => {
    if (saving) {
      deleteClutch();
    }
  }, [saving]);


  useEffect(() => {
    appendControls(<div className="text-center w-100">
      <span className="d-flex"  >
        <Button variant="outline-light" disabled={saving} onClick={() => setSaving(true)} className="mx-auto">Delete Clutch</Button>
      </span>
    </div>, 'Delete Clutch');
  }, []);

  return (
    <ReptoolModal id='delete-clutch-modal' title={'Are you sure you want to delete this clutch?'} closeModal={closeModal} body={
      <ClutchItem clutch={editingClutch} refetch={() => { }} hideActions={true} />
    }>
    </ReptoolModal>
  );
};

export default DeleteClutchModal;
